import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-add",
  "use": "gw-add-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-add\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol